import { render, staticRenderFns } from "./MultiboxFacet.vue?vue&type=template&id=57a2eb23&"
import script from "./MultiboxFacet.vue?vue&type=script&lang=js&"
export * from "./MultiboxFacet.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports